// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__q0xUA","empty":"ModalGraph_empty__3LVfN"};